import { Component, Input, OnInit } from '@angular/core';
import { TooltipService } from 'app/services/tooltip-service';

declare var jQuery;

@Component({
  selector: 'info-tooltip2',
  templateUrl: './info-tooltip2.component.html',
  styleUrls: ['./info-tooltip2.component.scss']
})
export class InfoTooltip2Component implements OnInit {
  @Input()
  titleName: string = '';

  @Input()
  key: string = '';

  @Input()
  color: string = 'gray';

  @Input()
  placement: string = 'top';

  @Input()
  tooltipValue: string = '';

  constructor(private tooltipService: TooltipService) {}

  ngOnInit() {
    const tooltipKey = this.key || this.titleName;
    this.tooltipValue =
      this.tooltipValue || this.tooltipService.getTooltipValue(tooltipKey);

    setTimeout(fn => {
      jQuery('[enTooltip]').tooltip({ animation: false });
    }, 100);
  }
}
